import { getDefaultStore } from 'jotai';

import {
  noteSuggestionsAtomFamily,
  personalisationDocumentDiffAtomFamily,
  personalisationProtocolAtomFamily,
} from '../../../../atoms/noteSuggestionsAtoms';
import {
  type NoteGenerationPhaseFrame,
  type NoteSuggestionsFrame,
} from '../../../../note-suggestions/types';

const jotaiStore = () => getDefaultStore();

export function resetGenerationPresentation(sessionId: string): void {
  jotaiStore().set(noteSuggestionsAtomFamily(sessionId), null);
  jotaiStore().set(personalisationProtocolAtomFamily(sessionId), null);
  jotaiStore().set(personalisationDocumentDiffAtomFamily(sessionId), null);
}

export function publishPersonalisationPhase(
  sessionId: string,
  phase: { generationId: string; phase: NoteGenerationPhaseFrame['phase'] }
): void {
  jotaiStore().set(personalisationProtocolAtomFamily(sessionId), {
    generationId: phase.generationId,
    phase: phase.phase,
  });
}

export function publishNoteSuggestions(
  sessionId: string,
  input: {
    strategies: NoteSuggestionsFrame['strategies'];
    baseText: string;
    mode: NoteSuggestionsFrame['mode'];
  }
): void {
  jotaiStore().set(noteSuggestionsAtomFamily(sessionId), {
    strategies: input.strategies,
    baseText: input.baseText,
    receivedAt: Date.now(),
    mode: input.mode,
  });
}

export function publishPersonalisationDiff(
  sessionId: string,
  diff: { generationId: string; beforeContent: string; afterContent: string }
): void {
  jotaiStore().set(personalisationDocumentDiffAtomFamily(sessionId), {
    generationId: diff.generationId,
    beforeContent: diff.beforeContent,
    afterContent: diff.afterContent,
  });
}

export function clearPersonalisationProtocol(sessionId: string): void {
  jotaiStore().set(personalisationProtocolAtomFamily(sessionId), null);
}
